import { useSelector } from 'react-redux';
import { RootState } from '../../../state/store';
import { useTranslation } from 'react-i18next';
import {
  InvoiceApiParams,
  InvoiceType,
  mapAppIdentToInvoiceType,
  mapInvoiceTypeToApiParams,
} from '../../../shared/invoice/invoiceConfig';

export type { InvoiceApiParams };
export { InvoiceType };

/**
 * Hook that retrieves selectedApp from Redux and maps its appIdent to InvoiceType enum and API params
 * @returns Object containing InvoiceType enum value and API params based on the current selectedApp's appIdent
 */
export const useInvoiceAppType = (): { invoiceType: InvoiceType; apiParams: InvoiceApiParams } => {
  const { t } = useTranslation('invoice');
  const _t = (key: string) => t(`invoice_filters.${key}`, { ns: 'invoice' });
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedApp);
  const appIdent = selectedApp?.appIdent || '';
  const invoiceType = mapAppIdentToInvoiceType(appIdent);
  const apiParams = mapInvoiceTypeToApiParams(invoiceType, _t);
  return { invoiceType, apiParams };
};

